import dayjs from 'dayjs';

import { GroupedSalesOrdersQuantitiesType, SalesOrdersQuantitiesType } from '@/graphql/contracts/_generated_/contracts';

export type GroupedSalesOrders = {
  consolidated?: SalesOrdersQuantitiesType[];
  nonConsolidated?: SalesOrdersQuantitiesType[];
};

const DATE_PATTERN = 'D MMMM YYYY';
const SHORT_DATE_PATTERN = 'D MMMM';
const HOURS_PATTERN = 'HH:mm';

export const tableMainHeaders = {
  beforeYesterday: dayjs().subtract(2, 'day').format(SHORT_DATE_PATTERN),
  yesterday: dayjs().subtract(1, 'day').format(SHORT_DATE_PATTERN),
  today: dayjs().format(SHORT_DATE_PATTERN),
  tonight: dayjs().add(1, 'day').format(SHORT_DATE_PATTERN),
};

export const getTotalCount = (salesOrdersGrouped: GroupedSalesOrders) => {
  if (salesOrdersGrouped?.consolidated?.length) {
    return (
      salesOrdersGrouped.consolidated.slice(-1)[0]?.count +
      (salesOrdersGrouped.nonConsolidated?.slice(-1)[0]?.count ?? 0)
    );
  }
  if (salesOrdersGrouped?.nonConsolidated?.length) {
    return (
      salesOrdersGrouped.nonConsolidated.slice(-1)[0]?.count +
      (salesOrdersGrouped.consolidated?.slice(-1)[0]?.count ?? 0)
    );
  }
  return null;
};

export const getDateHeader = (salesOrders: GroupedSalesOrdersQuantitiesType, index: number) => {
  const salesOrdersWithNumbers = salesOrders.consolidated?.length
    ? salesOrders.consolidated
    : salesOrders.nonConsolidated;

  if (salesOrdersWithNumbers?.length) {
    return (
      <div>
        As of {dayjs(salesOrdersWithNumbers.slice(-1)[0]?.created).format(HOURS_PATTERN)} <br />
        {dayjs(salesOrdersWithNumbers.slice(-1)[0]?.created).format(DATE_PATTERN)}
      </div>
    );
  }
  if (index === Object.keys(tableMainHeaders).length - 1) {
    return (
      <div>
        Available <br />
        {dayjs().add(1, 'day').format(DATE_PATTERN)} <br />
        at 7:00am
      </div>
    );
  }

  return (
    <div>
      As of {dayjs(new Date()).format(HOURS_PATTERN)} <br />
      {dayjs(new Date()).format(DATE_PATTERN)}
    </div>
  );
};
